/**
 * Basic theme functions
 */

const BASIC = {
    onReady: () => {
        document.body.classList.add('js');

        BASIC.getBreakpoint();
        BASIC.initNavbar();
        BASIC.initNavbarSubmenu();
        
        window.addEventListener('resize', () => {
            BASIC.getBreakpoint();
        });

        document.dispatchEvent( new Event('scroll') );

    },


    /**
     * Get css breakpoint name in JS
     *
     * @returns (string) 'mobile', 'tablet', 'desktop', 'widescreen', 'fullhd'
     */
    getBreakpoint: () => {
        let html = document.querySelector('html');
        let content = window.getComputedStyle(html, '::after')['content'];

        return content.replace(/["']*/g, '');
    },


    /**
     * Add basic navbar functionality
     */
    initNavbar: () => {

        /* burger menu trigger */
        let burgers = document.querySelectorAll('.navbar-burger');

        burgers.forEach((burger) => {
            burger.addEventListener('click', () => {
                const data = burger.getAttribute('aria-controls');
                const target = document.getElementById(data);

                let active = !burger.classList.contains('is-active');

                burger.classList.toggle('is-active');
                burger.setAttribute('aria-expanded', active);
                target.classList.toggle('is-active');
            });
        });


        /* condensed navbar */
        let navbar = document.querySelector('.navbar');

        if ( navbar != null ) {
            var scrollPos = 0;
            window.addEventListener('scroll', () => {
                if ((document.body.getBoundingClientRect()).top >= 0 || (document.body.getBoundingClientRect()).top > scrollPos + 10) {
                    navbar.classList.remove('is-condensed'); /* scrolling UP */
                } else if ( (document.body.getBoundingClientRect()).top < scrollPos - 10 ) {
                    navbar.classList.add('is-condensed'); /* scrolling DOWN */
                }
                scrollPos = (document.body.getBoundingClientRect()).top;
            });

        }
    },


    /**
     * Add submenu item trigger
     */
    initNavbarSubmenu: () => {
        let parents = document.querySelectorAll('.menu-item-has-children');

        parents.forEach((parent, i) => {
            let id = 'submenu' + i;
            let trigger = BASIC.createNavbarSubmenuTrigger(id);
            
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                let active = !parent.classList.contains('is-active');

                trigger.setAttribute('aria-expanded', active);
                parent.classList.toggle('is-active');
            });

            parent.querySelector('.sub-menu').setAttribute('id', id);
            parent.querySelector('a').append(trigger);
        });
    },

    createNavbarSubmenuTrigger: (id) => {
        let trigger = document.createElement('span');
        trigger.classList.add('menu-trigger');
        trigger.setAttribute('aria-controls', id);
        trigger.setAttribute('aria-expanded', false);
        trigger.setAttribute('aria-label', 'Submenu');
        trigger.setAttribute('role', 'button');

        return trigger;
    },
}

BASIC.onReady();
